import { AddIcon } from '@approvalmax/ui';
import { Button, Divider, Flex, Popup, Spacing } from '@approvalmax/ui/src/components';
import { Fragment, memo } from 'react';

import { actionsRightWidth } from '../../ReportSchedulerPopup.constants';
import { useReportSchedulerContext } from '../../ReportSchedulerPopup.context';
import { messages } from '../../ReportSchedulerPopup.messages';
import { RuleRow } from '../RuleRow/RuleRow';
import { ContentPopupProps } from './ContentPopup.types';

export const ContentPopup = memo<ContentPopupProps>((props) => {
    const { isOpen, onToggle } = props;

    const { schedule, updateRuleName, addNewRule, removeRule, save, loading } = useReportSchedulerContext();

    return (
        <Popup open={isOpen} onToggle={onToggle}>
            <Popup.Header
                title={messages.title}
                progress={loading}
                actions={
                    <Flex width={actionsRightWidth}>
                        <Button size='medium' color='blue80' onClick={save} disabled={loading} block>
                            {messages.buttonSave}
                        </Button>
                    </Flex>
                }
            />

            <Popup.Body>
                {schedule.rules.map((rule, index) => (
                    <Fragment key={index}>
                        <RuleRow rule={rule} ruleIndex={index} onUpdate={updateRuleName} onDelete={removeRule} />

                        {index < schedule.rules.length - 1 && <Divider spacing='16 0 24 0' />}
                    </Fragment>
                ))}

                <Spacing height={24} />

                <Button color='blue80' onClick={addNewRule} startIcon={<AddIcon />}>
                    {messages.buttonAdd}
                </Button>
            </Popup.Body>
        </Popup>
    );
});

ContentPopup.displayName = 'ContentPopup';
